var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1313 1.69268C11.3863 1.40781 11.3621 0.970135 11.0773 0.715096C10.7924 0.460058 10.3547 0.484236 10.0997 0.7691L6.98967 4.2428C6.35948 4.94668 5.93509 5.41822 5.57225 5.72319C5.2266 6.01371 5.02358 6.07704 4.84623 6.07704C4.66889 6.07704 4.46587 6.01371 4.12022 5.72319C3.75737 5.41822 3.33298 4.94668 2.7028 4.2428L1.90049 3.34666C1.64545 3.0618 1.20777 3.03762 0.922908 3.29266C0.638044 3.5477 0.613866 3.98538 0.868905 4.27024L1.70549 5.20466C2.29243 5.86028 2.782 6.40715 3.22933 6.78313C3.70253 7.18086 4.21294 7.46166 4.84623 7.46166C5.47953 7.46166 5.98994 7.18086 6.46314 6.78313C6.91047 6.40715 7.40003 5.86029 7.98697 5.20467L11.1313 1.69268Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheck);
export default __webpack_public_path__ + "static/media/checkbox-check.d3eb073da66e33e0f809fbec96737a47.svg";
export { ForwardRef as ReactComponent };